import { TaskFilterType } from "./TaskFilterChips";

/**
 * Returns the default omnisearch string for the tasks page. URL `omnisearch`
 * values override keys via OmnisearchDataDisplay's smart merge.
 */
export function getDefaultTaskSearch(
  tenantId: string | undefined,
  activeFilter: TaskFilterType | null
): string {
  const base = `tenantId:${tenantId}`;

  switch (activeFilter) {
    case TaskFilterType.Overdue:
      return `${base} status:OVERDUE`;
    case TaskFilterType.Completed:
      return `${base} taskStatus:COMPLETED`;
    case TaskFilterType.Open:
      return `${base} taskStatus:OPEN|IN_PROGRESS`;
    case TaskFilterType.AllButCanceled:
    default:
      return `${base} taskStatus:OPEN|IN_PROGRESS|COMPLETED`;
  }
}
